import {
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { withPaymentMethodFieldGroup } from './usePaymentMethodForm';
import { useBookkeepingAccounts } from '../../../stores/FetcherStores/BookkeepingAccountFetcher';
import BookkeepingAccount from '../../../model/BookkeepingAccount';
import useCompanyId from '../../../hooks/useCompanyId';

const SharedPaymentMethodFieldGroup = withPaymentMethodFieldGroup({
  defaultValues: {
    name: '',
    shortName: '',
    active: true,
    bookkeepingAccount: '',
  },
  props: {},
  render: function Render({ group }) {
    const { t } = useTranslation();
    const companyId = useCompanyId();
    const { data: accountList = [] } = useBookkeepingAccounts(companyId);

    return (
      <>
        <Grid item xs={12} md={6}>
          <group.Field name="name">
            {(field) => (
              <TextField
                id="name"
                label={t('paymethodScreen.name')}
                variant="outlined"
                value={field.state.value}
                onChange={(e) => field.handleChange(e.target.value)}
                fullWidth
              />
            )}
          </group.Field>
        </Grid>
        <Grid item xs={12} md={6}>
          <group.Field name="shortName">
            {(field) => (
              <TextField
                id="shortName"
                label={t('paymethodScreen.shortName')}
                variant="outlined"
                value={field.state.value}
                onChange={(e) => field.handleChange(e.target.value)}
                fullWidth
              />
            )}
          </group.Field>
        </Grid>
        <Grid item xs={12} md={6}>
          <group.Field name="active">
            {(field) => (
              <FormControl>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={field.state.value || false}
                        onChange={(e) => field.handleChange(e.target.checked)}
                        color="info"
                        name="active"
                      />
                    }
                    label={
                      field.state.value
                        ? t('paymethodScreen.active')
                        : t('paymethodScreen.inactive')
                    }
                  />
                </FormGroup>
              </FormControl>
            )}
          </group.Field>
        </Grid>
        {accountList && accountList.length !== 0 && (
          <group.Field name="bookkeepingAccount">
            {(field) => (
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel id="account-id-label">
                    {t('paymethodScreen.bookkeepingAccount')}
                  </InputLabel>
                  <Select
                    labelId="account-id-label"
                    id="account-id-select"
                    value={field.state.value || ''}
                    defaultValue=""
                    label={t('paymethodScreen.bookkeepingAccount')}
                    onChange={(e) => field.handleChange(e.target.value)}
                  >
                    {accountList?.map((account: BookkeepingAccount) => (
                      <MenuItem key={account.id} value={account.id}>
                        {`${account.number} - ${account.name}`}
                      </MenuItem>
                    ))}
                    <MenuItem value="">{t('paymethodScreen.noAccount')}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            )}
          </group.Field>
        )}
      </>
    );
  },
});

export default SharedPaymentMethodFieldGroup;
